import React, { useEffect, useState } from "react";
import { Button, DatePicker } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import "./App.css";

const { RangePicker } = DatePicker;

const APP_LUCE_COM_EVENTS = [
  "page_view",
  "scroll",
  "find_availability",
  "add_to_cart",
  "user_sign_up",
  "user_sign_in",
  "wa_sales_button_click",
  "app_download_button_click",
  "redirect_to_old_app",
  "purchase",
];
const APP_LUCEMG_COM_EVENTS = ["page_view", "purchase", "redirect_to_new_app"];
const LUCE_SG_EVENTS = [
  "page_view",
  "scroll",
  "book_now_button_click",
  "book_service_popup_button_click",
  "popup_book_online_button_click",
  "popup_wa_sales_button_click",
  "form_submit",
  "floating_wa_initial_icon_click",
  "floating_wa_start_chat_click",
  "book_service_wa_button_click",
  "app_download_button_click",
];

const EventSection = ({
  events,
  dataList,
  dateRange,
  setDateRange,
  platform,
  loading,
}: {
  events: string[];
  dataList: any[];
  dateRange: [Date, Date];
  setDateRange(dateRange: [Date, Date]): void;
  platform: string;
  loading: boolean;
}) => {
  return (
    <section>
      <div className="flex flex-row justify-between pb-4">
        <RangePicker
          disabled={!dataList.length}
          value={dateRange.map((date) => dayjs(date)) as any}
          onChange={(dateRange: any) => {
            setDateRange(dateRange.map((date: any) => new Date(date)));
          }}
        />
        {/* <Button>{dataList.length ? "refresh" : "loading..."}</Button> */}
        <div>{`status: ${loading ? "loading..." : "done"}`}</div>
      </div>
      <div className="bg-[#eff6ff] text-[#075985]">
        {events.map((e, i) => {
          return (
            <div className="flex flex-row border-b p-2 gap-4">
              <div className="w-[120px]">{platform}</div>
              <div className="w-[280px]">{e}</div>
              <div className="">
                {typeof dataList[i] === "string"
                  ? dataList[i]
                  : dataList[i]?.filter((data: any) => {
                      return (
                        dateRange[0].getTime() <=
                          new Date(data?.timestamp).getTime() &&
                        dateRange[1].getTime() >=
                          new Date(data?.timestamp).getTime()
                      );
                    })?.length}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

const startOfDay = dayjs().subtract(2, "day").startOf("day").toDate();
const endOfDay = dayjs().subtract(1, "day").startOf("day").toDate();

function App() {
  const [luceComeData, setLuceComData] = useState<any>([]);
  const [luceSgData, setLuceSgData] = useState<any>([]);
  const [luceMgData, setLuceMgData] = useState<any>([]);

  const [luceComeLoading, setLuceComLoading] = useState(false);
  const [luceSgLoading, setLuceSgLoading] = useState(false);
  const [luceMgLoading, setLuceMgLoading] = useState(false);

  const [luceComDateRange, setLuceComDateRange] = useState<[Date, Date]>([
    startOfDay,
    endOfDay,
  ]);
  const [LuceSgDateRange, setLuceSgDateRange] = useState<[Date, Date]>([
    startOfDay,
    endOfDay,
  ]);
  const [LuceMgDateRange, setLuceMgDateRange] = useState<[Date, Date]>([
    startOfDay,
    endOfDay,
  ]);

  const fetchLuceCom = () => {
    fetchData(
      APP_LUCE_COM_EVENTS,
      "app_luce_com",
      setLuceComData,
      luceComDateRange,
      setLuceComLoading
    );
  };

  const fetchLuceMg = () => {
    fetchData(
      APP_LUCEMG_COM_EVENTS,
      "app_lucemg_com",
      setLuceMgData,
      LuceMgDateRange,
      setLuceMgLoading
    );
  };

  const fetchLuceSg = () => {
    fetchData(
      LUCE_SG_EVENTS,
      "luce_sg",
      setLuceSgData,
      LuceSgDateRange,
      setLuceSgLoading
    );
  };

  const fetchData = (
    events: string[],
    acceptPrifile: string,
    cb: (data: any) => void,
    dateRange: [Date, Date],
    setLoading: (loading: boolean) => void
  ) => {
    const start = dateRange[0].toISOString();
    const end = dateRange[1].toISOString();

    setLoading(true);
    Promise.allSettled(
      events.map((v) =>
        axios.get(`/api/${v}?timestamp=gte.${start}&timestamp=lt.${end}`, {
          headers: {
            "Accept-Profile": acceptPrifile,
          },
        })
      )
    )
      .then((res) => {
        const data = res.map((p) => {
          if (p.status === "fulfilled") {
            return p.value?.data;
          }
          return p?.reason?.message;
        });
        return data;
      })
      .then((data) => {
        cb(data);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchLuceMg();
  }, [LuceMgDateRange]);

  useEffect(() => {
    fetchLuceSg();
  }, [LuceSgDateRange]);

  useEffect(() => {
    fetchLuceCom();
  }, [luceComDateRange]);

  return (
    <div className="App p-6 flex flex-col gap-8">
      <EventSection
        events={APP_LUCE_COM_EVENTS}
        dataList={luceComeData}
        dateRange={luceComDateRange}
        setDateRange={setLuceComDateRange}
        platform="app.luce.com"
        loading={luceComeLoading}
      />

      <EventSection
        events={LUCE_SG_EVENTS}
        dataList={luceSgData}
        dateRange={LuceSgDateRange}
        setDateRange={setLuceSgDateRange}
        platform="luce.sg"
        loading={luceSgLoading}
      />

      <EventSection
        events={APP_LUCEMG_COM_EVENTS}
        dataList={luceMgData}
        dateRange={LuceMgDateRange}
        setDateRange={setLuceMgDateRange}
        platform="app.lucemg.com"
        loading={luceMgLoading}
      />
    </div>
  );
}

export default App;
